import {
  useRef
} from 'react';
import {
  NOT
} from '../../../lib/Boolean.lib';
import fetchCandidateResume from '../../../lib/Candidate/fetchCandidateResume.async';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import useState from '../../../lib/hooks/useState.hook';
import Box from '../../Layout/Wrappers/Box';
import Message from '../../Layout/Wrappers/Message';
import TextCVContentDrawer from "../../Match/Job/TextCVContentDrawer";

export default function DoubleContentDrawer({
  candidate = {},
  job = {},
  ...props
}) {
  const mem = useRef({});
  const [state, updateState] = useState();
  (async () => {
    if (
      NOT(candidate.id)
      || mem.current.busy
      || mem.current.ready
      || mem.current.error
    ) { return; }
    mem.current.busy = true;
    try {
      const localUrlCandidateResumePdf = await fetchCandidateResume({
        key: 'pdf',
        type: 'blob',
        candidate,
        source: 'DoubleContentDrawer',
      });
      fetchCandidateResume({
        key: 'highlighted',
        type: 'blob',
        candidate,
        jobId: job.id,
        employerId: job.employerId,
        source: 'DoubleContentDrawer',
      }).then(
        (localUrlCandidateResumePdfHighlights) => updateState({
          resumeHighlightsUrl: localUrlCandidateResumePdfHighlights
        })
      ).catch(
        (error) => updateState({ error })
      );
      await updateState({
        resumePdfUrl: localUrlCandidateResumePdf,
      });
      mem.current.ready = true;
    }
    catch (error) {
      mem.current.error = error;
      globalErrorHandler(error);
    }
    mem.current.busy = false;
  })();
  const VALUE__LOCAL_URL = (
    state.resumeHighlightsUrl ||
    state.resumePdfUrl
  );
  console.debug(
    'DoubleContentDrawer',
    { VALUE__LOCAL_URL, job }
  );
  return (
    <Box row w100 h100 wrap
      {...props}
    >
      <Box column flex1 h100 scrollY
        style={{ minWidth: 320 }}
      >
        {!!candidate.resumeTxtUrl && !!job.id
          ? (
            <TextCVContentDrawer
              style={{ width: "100%", height: "100%" }}
              candidate={candidate}
              job={job}
            />
          ) : (
            <Message>No Text CV</Message>
          )}
      </Box>

      <Box column flex1 h100
        style={{ minWidth: 320 }}
      >
        {VALUE__LOCAL_URL
          ? (
            <iframe
              title='double_content_drawer__iframe'
              src={`${VALUE__LOCAL_URL}#view=fitH&toolbar=1`}
              type="application/pdf"
              width="100%"
              height="100%"
              className="h-100"
            />
          ) : (
            <Message>No CV</Message>
          )}
      </Box>
    </Box>
  );
}
